// Deterministic per-person avatar tone so the same person is always one colour.
// Extracted from the copies in the table-column modules; new callers use this.

import type { AvatarTone } from '@/components/common';

const TONES: AvatarTone[] = ['brand', 'blue', 'purple', 'green', 'amber', 'red'];

/** Same name (or id) in → same tone out. */
const toneOf = (seed: string): AvatarTone => {
  let sum = 0;
  for (let i = 0; i < seed.length; i += 1) sum += seed.charCodeAt(i);
  return TONES[sum % TONES.length];
};

export default toneOf;
